export const STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Ativo' },
  { value: 'INACTIVE', label: 'Inativo' },
];

export const initialValues = {
  name: '',
  document: '',
  phone_number: '',
  tenant_id: '',
  user_id: '',
  start_date: '',
  end_date: '',
  area_id: [],
  status_flag: 'ACTIVE',
  images: [],
};